import * as angular from "angular";
import {DataHubService} from "../../modules/DataHubModule";
import {IComponentController, IDeferred, IScope} from "angular";
import {TxnTemplateDto} from "../../model/TxnTemplateDto";
import {Ng1Controller, Transition, TargetState} from "@uirouter/angularjs";
import * as moment from "moment/moment";
import {Guid} from "guid-typescript";
import {DisposeBag} from "../../modules/DisposeBag";

class TxnTemplateViewController implements IComponentController {
    private disposeBag = new DisposeBag();
    model: TxnTemplateDto;
    txnTemplateGuid: Guid;
    private resolve: any; // ui-bootstrap magic
    private processing: boolean;

    constructor(private $dataHub: DataHubService,
                private $scope: IScope) {
        $dataHub.onTxnTemplateOneUpdated(e => {
            if (e.guid !== this.txnTemplateGuid) return;
            this.model = e;
        }, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    $onInit(): void {
        this.txnTemplateGuid = this.resolve.txnTemplateGuid;
        this.reload();
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.reload();
    }

    $onDestroy?() {
        this.disposeBag.finalize();
    }


    reload = () => {
        console.debug('reload', this.txnTemplateGuid);
        this.model = null;
        if (!this.$dataHub.isConnected) return;
        if (this.txnTemplateGuid)
            this.$dataHub.txnTemplateSubscribeOne(this.txnTemplateGuid)
                .catch(this.$dataHub.defaultErrorHandler);
    };

    process = () => {
        this.processing = true;
        this.$dataHub.txnTemplateProcessOne(this.model.guid)
            .catch(this.$dataHub.defaultErrorHandler)
            .finally(() => this.processing = false);
    };

    clearReview = () => {
        this.$dataHub.txnTemplateReviewClear(this.model.guid)
            .catch(this.$dataHub.defaultErrorHandler);
    };

    get nextInPast() {
        if (this.model?.interval?.next == null) return false;
        return this.model.interval.next < moment().startOf('day').toDate();
    }


}


export default angular.module('app.txnTemplate.view', [])
    .component('txnTemplateViewModal', {
        template: require('./TxnTemplateView.html'),
        controller: TxnTemplateViewController,
        controllerAs: 'vm',
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
    }).name;
